import { useScreenSize } from '@hooks';
import { Button, Flex, theme, Typography } from '@styles';
import { bool, func, oneOf } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const FinishCard = ({
  onFinishButtonPress,
  onTryAgainButtonPress,
  status,
  withContinue,
  withFinish,
}) => {
  const { i18n } = useTranslation();
  const { isTabletSM } = useScreenSize();

  const text = {
    fail: i18n.t('TestPage.PracticeMore'),
    success: i18n.t('TestPage.Pass'),
  };

  return (
    <Flex flexDirection="column" mb={75} mt={3} width="100%">
      <Flex
        alignItems="center"
        backgroundColor={theme.colors.hunterGreen[90]}
        borderColor={theme.colors.whiteLine[100]}
        borderStyle="solid"
        borderWidth={1}
        flexDirection="column"
        height="362px"
        justifyContent="center"
        mb={24}
      >
        <Typography
          color={theme.colors.white[100]}
          mb={3}
          textAlign="center"
          variant={isTabletSM ? 'BN-bold-s56-lh67' : 'BN-bold-s88-lh75'}
        >
          {text[status]}
        </Typography>
      </Flex>
      {withContinue ? (
        <Button
          maxWidth={isTabletSM ? '100%' : 280}
          onClick={onFinishButtonPress}
          variant="primary"
          whiteSpace="nowrap"
          width="100%"
        >
          <Typography
            color={theme.colors.black[100]}
            variant="MS-semibold-s16-lh25"
          >
            {i18n.t('ScenarioPage.Continue').toUpperCase()}
          </Typography>
        </Button>
      ) : (
        <Flex
          flexDirection={isTabletSM ? 'column' : 'row'}
          gap={isTabletSM ? 24 : 16}
          justifyContent={withFinish ? 'space-between' : 'center'}
          width="100%"
        >
          <Button
            maxWidth={isTabletSM ? '100%' : 395}
            onClick={onTryAgainButtonPress}
            variant="secondary"
            whiteSpace="nowrap"
            width="100%"
          >
            <Typography variant="MS-semibold-s16-lh25">
              {i18n.t('ScenarioPage.TryAgain').toUpperCase()}
            </Typography>
          </Button>
          {withFinish && (
            <Button
              maxWidth={isTabletSM ? '100%' : 395}
              onClick={onFinishButtonPress}
              variant="primary"
              whiteSpace="nowrap"
              width="100%"
            >
              <Typography
                color={theme.colors.black[100]}
                variant="MS-semibold-s16-lh25"
              >
                {i18n.t('ScenarioPage.Finish').toUpperCase()}
              </Typography>
            </Button>
          )}
        </Flex>
      )}
    </Flex>
  );
};

FinishCard.propTypes = {
  onFinishButtonPress: func.isRequired,
  onTryAgainButtonPress: func.isRequired,
  status: oneOf(['success', 'fail']),
  withContinue: bool,
  withFinish: bool,
};

FinishCard.defaultProps = {
  status: 'success',
  withContinue: false,
  withFinish: true,
};

export default FinishCard;
